import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO ứng dụng công nghệ Digital Twin để hiện thực hóa đồ họa đô thị sống động một cách chân thực và tăng cường khả năng trực quan hóa đô thị. Để thực hiện điều này, ORBRO cung cấp các giải pháp biểu diễn đồ họa độ phân giải cao cấp độ LDO5, kết nối dữ liệu đồ họa bên ngoài, hỗ trợ dữ liệu đồ họa chính xác dựa trên kinh độ - vĩ độ, mô hình 3D có khả năng tương tác, bảo tồn kỹ thuật số di sản lịch sử và văn hóa, cùng các mô phỏng quy hoạch và phát triển đô thị.',
  keywords: 'Bản sao số, CCTV, thành phố số, thực tế ảo, ban sao so, CCTV, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Xây dựng thành phố với đồ họa sống động',
  title: 'Digital Twin - Xây dựng thành phố với đồ họa sống động',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-digitalcity',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Cctv',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Xây dựng đồ họa đô thị sống động',
      subHead: '',
      desc: 'ORBRO ứng dụng công nghệ Digital Twin để hiện thực hóa đồ họa đô thị sống động một cách chân thực và tăng cường khả năng trực quan hóa đô thị. Để thực hiện điều này, ORBRO cung cấp các giải pháp biểu diễn đồ họa độ phân giải cao cấp độ LDO5, kết nối dữ liệu đồ họa bên ngoài, hỗ trợ dữ liệu đồ họa chính xác dựa trên kinh độ - vĩ độ, mô hình 3D có khả năng tương tác, bảo tồn kỹ thuật số di sản lịch sử và văn hóa, cùng các mô phỏng quy hoạch và phát triển đô thị.\nKhả năng biểu diễn đồ họa độ phân giải cao của ORBRO giúp trực quan hóa đô thị một cách thực tế, mang lại trải nghiệm đắm chìm cho người dùng, và việc kết nối dữ liệu đồ họa bên ngoài giúp tích hợp hiệu quả thông tin đô thị đa dạng và chính xác. Hơn nữa, dữ liệu đồ họa dựa trên kinh độ - vĩ độ cho phép cung cấp thông tin vị trí chính xác và phân tích địa lý.\nMô hình 3D có khả năng tương tác giúp người dùng khám phá và phân tích các phần khác nhau của đô thị theo thời gian thực, và việc bảo tồn kỹ thuật số di sản lịch sử và văn hóa giúp bảo vệ giá trị của đô thị cũng như tăng cường các khía cạnh giáo dục. Không chỉ vậy, các mô phỏng quy hoạch và phát triển đô thị còn hỗ trợ việc xây dựng chiến lược hiệu quả và ra quyết định phát triển, thúc đẩy sự phát triển bền vững của đô thị.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Biểu diễn đồ họa sống động cấp độ LDO5',
      desc: 'ORBRO trực quan hóa diện mạo đô thị một cách chân thực bằng đồ họa có độ chi tiết và độ phân giải ở mức cao nhất (cấp độ LDO5). Điều này được ứng dụng trong quy hoạch đô thị, thiết kế, tiếp thị, và mang lại trải nghiệm người dùng mới thông qua việc tích hợp với thực tế ảo (VR) và thực tế tăng cường (AR).',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết nối dữ liệu đồ họa bên ngoài',
      desc: 'ORBRO thu thập và tích hợp dữ liệu đồ họa từ nhiều nguồn bên ngoài khác nhau để cung cấp các mô hình đô thị chính xác và phong phú hơn. Điều này giúp cải thiện khả năng biểu diễn trực quan của đô thị và đóng góp vào việc phân tích cũng như lập kế hoạch đô thị chính xác.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hỗ trợ dữ liệu đồ họa dựa trên tọa độ (kinh độ, vĩ độ)',
      desc: 'ORBRO hỗ trợ dữ liệu đồ họa dựa trên tọa độ kinh độ và vĩ độ, cho phép cung cấp thông tin vị trí chính xác và phân tích địa lý. Điều này được ứng dụng trong quy hoạch đô thị, phát triển bất động sản, ngành du lịch, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cung cấp mô hình 3D có khả năng tương tác',
      desc: 'ORBRO cung cấp các mô hình 3D mà người dùng có thể tương tác, cho phép họ khám phá và phân tích các yếu tố đa dạng của đô thị theo thời gian thực. Điều này được ứng dụng trong quy hoạch, giáo dục, mô phỏng, v.v.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bảo tồn kỹ thuật số di sản lịch sử và văn hóa',
      desc: 'ORBRO số hóa và bảo tồn các công trình lịch sử hoặc di sản văn hóa dưới dạng 3D. Điều này giúp thúc đẩy việc bảo vệ di sản văn hóa và nâng cao giá trị giáo dục của chúng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mô phỏng quy hoạch và phát triển đô thị',
      desc: 'ORBRO sử dụng đồ họa tương tự thực tế để mô phỏng các kịch bản quy hoạch và phát triển đô thị. Điều này cung cấp thông tin thiết yếu cho việc lập kế hoạch hiệu quả và ra quyết định phát triển.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
